export default __webpack_public_path__ + "static/media/element_spec_29.34505a2a.webp";